import { inheritsLoose as _inheritsLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as time from 'd3-time';
import { withTheme } from 'styled-components';
import AxisTicks from './AxisTicks.js';
import AxisLine from './AxisLine.js';
import Label from './Label.js';

var _class;
var YAxis = withTheme(( // eslint-disable-next-line zillow/react/prefer-stateless-function
_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(YAxis, _Component);
  function YAxis() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = YAxis.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      yOrient = _this$props.yOrient,
      yAxisOffset = _this$props.yAxisOffset,
      width = _this$props.width,
      yAxisTickCount = _this$props.yAxisTickCount,
      yAxisTickInterval = _this$props.yAxisTickInterval,
      yAxisClassName = _this$props.yAxisClassName,
      _this$props$stroke = _this$props.stroke,
      stroke = _this$props$stroke === void 0 ? this.props.theme.constellation.colors.textDark : _this$props$stroke,
      yScale = _this$props.yScale,
      margins = _this$props.margins,
      height = _this$props.height,
      tickSize = _this$props.tickSize,
      tickFormatting = _this$props.tickFormatting,
      _this$props$tickStrok = _this$props.tickStroke,
      tickStroke = _this$props$tickStrok === void 0 ? this.props.theme.constellation.colors.textDark : _this$props$tickStrok,
      tickTextStroke = _this$props.tickTextStroke;
    var translate = "translate(" + (yAxisOffset + (yOrient === 'right' ? width : 0)) + ")";
    var tickArguments;
    if (yAxisTickCount) {
      tickArguments = [yAxisTickCount];
    }
    if (yAxisTickInterval) {
      tickArguments = [time[yAxisTickInterval.unit], yAxisTickInterval.interval];
    }
    return /*#__PURE__*/React.createElement("g", {
      className: yAxisClassName,
      transform: translate
    }, /*#__PURE__*/React.createElement(AxisTicks, {
      innerTickSize: tickSize,
      orient: yOrient,
      tickArguments: tickArguments,
      tickFormatting: tickFormatting,
      tickStroke: tickStroke,
      tickTextStroke: tickTextStroke,
      scale: yScale
    }), /*#__PURE__*/React.createElement(AxisLine, _extends({
      orient: yOrient,
      outerTickSize: tickSize,
      scale: yScale,
      stroke: stroke
    }, this.props)), /*#__PURE__*/React.createElement(Label, {
      height: height,
      label: "",
      margins: margins,
      orient: yOrient
    }));
  };
  return YAxis;
}(Component), _class.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.string,
  tickStroke: PropTypes.string,
  width: PropTypes.number.isRequired,
  yAxisClassName: PropTypes.string,
  yAxisLabel: PropTypes.string,
  yAxisOffset: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  yAxisTickValues: PropTypes.array,
  yOrient: PropTypes.oneOf(['left', 'right']),
  yScale: PropTypes.func.isRequired,
  yAxisTickCount: PropTypes.number,
  yAxisTickInterval: PropTypes.number,
  height: PropTypes.number,
  tickSize: PropTypes.number,
  tickFormatting: PropTypes.func,
  tickTextStroke: PropTypes.string,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  margins: PropTypes.object,
  yAxisLabelOffset: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
}, _class.defaultProps = {
  fill: 'none',
  strokeWidth: '1',
  yAxisClassName: 'rd3-y-axis',
  yAxisOffset: 0,
  yOrient: 'left'
}, _class));
var YAxis$1 = YAxis;

export { YAxis$1 as default };
